import { Day } from '@elio/shared/models';
import { addXDaysToDate } from './date.utils';

export const DAYS_IN_WEEK = 7;

export function findFirstDayOfWeek(date: Date, firstDayOfWeek: Day): Date {
  const firstDayOfWeekAsInt = day2Number(firstDayOfWeek);
  let daysToRemove = (date.getDay() - firstDayOfWeekAsInt) % 7;
  if (daysToRemove < 0) {
    daysToRemove += 7;
  }
  return addXDaysToDate(date, -daysToRemove);
}

function day2Number(day: Day): number {
  switch (day) {
    case 'SUN':
      return 0;
    case 'MON':
      return 1;
    case 'TUE':
      return 2;
    case 'WED':
      return 3;
    case 'THU':
      return 4;
    case 'FRI':
      return 5;
    case 'SAT':
      return 6;
  }
}
